import { Box, Button, useTheme } from '@mui/material';
import PlateFormSection from './PlateFormSection';
import SubsidiaryDetails from '@shared/components/SubsidiarySelectorContent/SubsidiaryDetails';

const PlateContactPointSection = ({ subsidiary, setSubsidiary }) => {
  const theme = useTheme();

  const content = (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      alignItems="flex-start"
      gap={5}
    >
      {/* Detalle del punto de venta */}
      <Box id="box-flex-plate-contact-point">
        <SubsidiaryDetails
          subsidiary={subsidiary}
          withLogo={true}
          imageWidth={140}
        />
      </Box>

      {/* Botones */}
      <Box display="flex" flexDirection="column" gap={2} alignSelf="center">
        <Button
          variant="outlined"
          onClick={() => setSubsidiary({})}
          sx={{
            width: '100%',
            height: '45px',
            borderRadius: '8px',
            color: theme.palette.text.primary,
            border: `1px solid ${theme.primary}`,
            boxShadow: 'none',
            fontSize: '18px',
            '&:hover': {
              bgcolor: theme.primary,
              color: theme.text1,
            },
          }}
        >
          Cambiar Punto de Venta
        </Button>

        <Button
          variant="contained"
          type="submit"
          sx={{
            width: '100%',
            height: '45px',
            borderRadius: '8px',
            bgcolor: theme.primary,
            color: '#000',
            fontSize: '18px',
            '&:hover': {
              bgcolor: theme.primary,
              color: '#000',
              fontWeight: 700,
            },
          }}
        >
          Enviar
        </Button>
      </Box>
    </Box>
  );

  return (
    <PlateFormSection
      title="Contacto de Punto de Venta"
      direction="row"
      xs={12}
      md={10}
      content={content}
    />
  );
};

export default PlateContactPointSection;
